import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiltroClientesnoRegistrados from "./FiltroClientesnoRegistrados";
import { useBox } from "../../CreditoyCobranza/ReporteCobranza/Helper/useBox";
import { GetKey } from "../../CreditoyCobranza/ReporteCobranza/Actions/GetContainer";
import ModalAgregarCliente from "./ModalAgregarCliente";

export const ListadoClientesNoRegistradosScreen = () => {
  const history = useHistory();
  const [selected, setSelected] = useState([]);
  const [predictivo, setPredictivo] = useState("");
  const [clientes, setClientes] = useState([]);
  const [arrayClientes, setArrayClientes] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const [openModalAgregar, setOpenModalAgregar] = useState(false);
  const [clienteAgregar, setClienteAgregar] = useState("")


  const handleCloseModalAgregar = () => {
    setOpenModalAgregar(false);
  };

  const handleOpenModal = (cliente) => {
    setOpenModalAgregar(true)
    setClienteAgregar(cliente)
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    onCargarCliente()
  }, []);

  const onCargarCliente = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ClientesNoRegistrados/Listado?sucursales=${0}&ADR=${"1,2"}`)
      .then((result) => {
        setClientes(result);
        setArrayClientes(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  }

  const onExecute = () => {
    // console.log(GetKey(boxstate.pv.sucursal, ["idsucursal"]))
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    // console.log(sucursales)
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    // console.log(adr, sucursales)
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `ClientesNoRegistrados/Listado?sucursales=${sucursales}&ADR=${adr}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setClientes(result);
          setArrayClientes(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  useEffect(() => {
    const result = arrayClientes.filter((item) =>
      item.razonSocial.toUpperCase().includes(predictivo.toUpperCase())
    );
    setSelected([]);
    setClientes(result);
  }, [predictivo]);

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const onGeneraExcel = () => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ClientesNoRegistrados/ImprimirExcel?sucursal=${sucursales}&adr=${adr}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CLIENTES NO REGISTRADOS", JSON.stringify(error), "error");
      });
  };

  // const onGeneraPDF = (responsable, linea, cartera, convenio, juridico) => {
  //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
  //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
  //     if (sucursales === undefined || sucursales === null || sucursales === "") {
  //         sucursales = "0";
  //     }
  //     if (adr === undefined || adr === null || adr === "") {
  //         adr = "0";
  //     }
  //     setLoader({ ...loader, mostrar: true });
  //     request
  //         .get(`ListadoClientesGestionarPrueba/ImprimirPDF?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`)
  //         .then((result) => {
  //             setLoader({ ...loader, mostrar: false });
  //             const linkSource = `data:application/pdf;base64, ${result.documento}`;
  //             const downloadLink = document.createElement("a");
  //             const fileName = `${result.nombredocumento}.${result.extension}`;
  //             downloadLink.href = linkSource;
  //             downloadLink.download = fileName;
  //             downloadLink.click();
  //         })
  //         .catch((error) => {
  //             setLoader({ ...loader, mostrar: false });
  //             Swal.fire("Clientes", JSON.stringify(error), "error");
  //         });
  // };

  return (
    <PlantillaScreen
      titulo={"CLIENTES NO REGISTRADOS EN HUMAYA DIGITAL"}
      className={"listado-clientes-noregistrados-main-screen"}
      className_main={1}
    >
      <div className="listado-clientes-noregistrados-actions">
        <div
          className="listado-clientes-noregistrados-actions-regresar"
          onClick={() => history.push("/Credito/Main")}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="listado-clientes-noregistrados-actions-filtro">
          <FiltroClientesnoRegistrados
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
          />
        </div>
        <div className="buttons-cne">
          <button className="excel" onClick={() => onGeneraExcel()}>
            <i className=" icon-file-excel" /> Excel
          </button>
          {/* <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(boxstate.responsable, boxstate.linea, boxstate.cartera, boxstate.convenio, boxstate.juridico)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button> */}
        </div>
      </div>
      <div className="contador-clientes-encontrados">
        Clientes Encontrados: {clientes.length}
      </div>
      <LoaderScreen loader={loader} />
      <div className="listado-clientes-noregistrados-screen">
        <div className="listado-clientes-noregistrados-header">
          <div className="listado-clientes-noregistrados-header-control">
            <TextField
              color="success"
              fullWidth
              size="small"
              value={predictivo}
              onChange={({ target }) => setPredictivo(target.value)}
              placeholder="Buscar Clientes..."
            />
          </div>
        </div>
        <div className="listado-clientes-noregistrados-container scroll-4">
          {clientes !== undefined &&
            clientes !== null &&
            clientes.length > 0 ? (
            <table cellSpacing={0} cellPadding={0}>
              <thead>
                <tr>
                  <th>Sucursal</th>
                  <th>
                    <div>ID Cliente Equip</div>
                  </th>
                  <th>
                    <div>Razon Social</div>
                  </th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                {clientes.map((ctl) => (
                  <tr>
                    <td className="celda-sucursal">
                      {capitalizeWords(ctl.descripcion)}
                    </td>
                    <td className="celda-equip">{ctl.idCliente}</td>
                    <td className="celda-razonsocial">
                      {capitalizeWords(ctl.razonSocial)}
                    </td>
                    <td>
                      <button className="button-agregar" onClick={() => handleOpenModal(ctl)}>Agregar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>Sin Datos</div>
          )}
          <div>
            <table></table>
          </div>
        </div>
        <ModalAgregarCliente
          open={openModalAgregar}
          onClose={handleCloseModalAgregar}
          usuario={clienteAgregar}
          cargar={onCargarCliente}
        />
      </div>
    </PlantillaScreen>
  );
};
